import ManagePost from './ManagePost';

export default ManagePost;